export const NAME = `projects`;
export const LINE_KWH = 0;
export const LINE_KW = 1;
export const STATUS_PROJECT_TYPE = 4;
export const COLUMNS_CONFIG = {
    name: {
        label: 'Name',
        is_active: true,
        required: true,
    },
    contact: {
        label: 'Contact',
        is_active: true,
        required: false,
    },
    status: {
        label: 'Status',
        is_active: true,
        required: false,
    },
    proposals: {
        label: 'Proposal_plural',
        is_active: true,
        required: false,
    },
    country: {
        label: 'Country',
        is_active: true,
        required: false,
    },
    state: {
        label: 'State',
        is_active: true,
        required: false,
    },
    created_at: {
        label: 'Created at',
        is_active: true,
        required: false,
    },
};
